import humps from 'humps'
import Api from '@/api'

export default {
  fetchCollectiveArbitrations(query) {
    return Api.get(`/collective_arbitrations`, { params: humps.decamelizeKeys(query) })
  },
  fetchCollectiveArbitration(collectiveArbitrationId) {
    return Api.get(`/collective_arbitrations/${collectiveArbitrationId}`)
  },
  fetchCollectiveArbitrationsAvailablePortfolios(query) {
    return Api.get(`/collective_arbitrations/available_portfolios`, { params: humps.decamelizeKeys(query) })
  },
  fetchCollectiveArbitrationsAvailableLines(query) {
    return Api.post(`/collective_arbitrations/available_lines`, query)
  },
  simulateCollectiveArbitrations(query) {
    return Api.post(`/collective_arbitrations/simulate`, query)
  },
  fetchCollectiveArbitrationsFees(query) {
    return Api.post(`/collective_arbitrations/fees`, query)
  },
  createCollectiveArbitrations(query) {
    return Api.post(`/collective_arbitrations`, query)
  },
  optimizeCollectiveArbitration(query) {
    return Api.post(`/collective_arbitrations/optimize`, query)
  },
}